import CryptoJS from 'crypto-js';

const key = CryptoJS.enc.Utf8.parse('9b519ae3894787ded16b30cb75eb73be');
const iv = CryptoJS.enc.Utf8.parse('4892783278419211');
const MD5_ALGORITHM = 'md5';

// 使用CBC模式和PKCS5Padding进行AES加密
export const encryptAES = (text) => {
  const cipher = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return cipher.toString();
};

// 使用CBC模式和PKCS5Padding进行AES解密
export const decryptAES = (encryptedText) => {
  const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

const generateMD5 = (input) => {
  return CryptoJS.MD5(input).toString();
};

const removeBase64Padding = (base64String) => {
  return base64String.replace(/={1,2}$/, '');
};

export const encrypt = (text) => {
  const timestamp = Math.floor(Date.now() / 1000); // Current timestamp in seconds

  try {
    // const iv = generateRandomIV();
    // Encrypt data using AES and remove base64 padding
    const encryptedData = removeBase64Padding(encryptAES(text, iv));

    // Generate MD5 hash
    const inputForHash = timestamp + text;
    const md5Hash = generateMD5(inputForHash);

    // Concatenate encrypted data + timestamp + md5

    return encryptedData + timestamp + md5Hash;
  } catch (error) {
    return 'Encryption failure';
  }
};

export const decrypt = (data) => {
  if (data === null || data === '' || data.length === 0) {
    return null;
  }
  const encryptedDataLength = data.length - 0x20 - 0xa;
  const encryptedData = data.substring(0, encryptedDataLength);
  const timestamp = parseInt(data.substring(encryptedDataLength, encryptedDataLength + 0xa));
  const md5Hash = data.substring(encryptedDataLength + 0xa);
  // Decrypt encryptedData
  const decrypt = decryptAES(encryptedData);

  // Calculate MD5 hash of timestamp + decrypted data
  const dataForHash = `${timestamp}${decrypt}`;
  const calculatedMD5 = calculateMD5(dataForHash);
  // Verify MD5 hash
  try {
    if (calculatedMD5 !== md5Hash) {
      throw new Error('Verify MD5 hash failed');
    }
  } catch (error) {
    return null;
  }

  // Return decrypted data
  return decrypt;
};

const calculateMD5 = (input) => {
  try {
    const hash = CryptoJS.MD5(input).toString();
    return hash;
  } catch (error) {
    return '';
  }
};

const generateRandomIV = () => {
  const ivSize = 16; // IV长度为16字节，对应128位
  const characters = '0123456789abcdef';
  let iv = '';

  for (let i = 0; i < ivSize * 2; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    iv += characters[randomIndex];
  }

  return iv;
};
